import React from 'react';

const Packages: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="journey" className="py-16 md:py-32 bg-gradient-to-br from-prussian-blue via-lapis-lazuli to-cerulean relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-celestial-blue/10 rounded-full blur-3xl smooth-pulse"></div>
        <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-alice-blue/10 rounded-full blur-3xl smooth-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-5xl">
        {/* Header Badge */}
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center bg-alice-blue/20 backdrop-blur-lg border border-alice-blue/30 text-alice-blue px-6 md:px-8 py-3 md:py-4 rounded-full text-xs md:text-sm font-semibold shadow-2xl fade-in">
            حصص القيادة المميزة
          </div>
        </div>

        {/* Main Title */}
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-3 md:mb-6 leading-tight fade-in fade-in-delay-1">
            احجزي حصتك
          </h2>
          <h3 className="text-4xl md:text-6xl lg:text-7xl font-black text-alice-blue mb-6 md:mb-10 leading-tight fade-in fade-in-delay-2">
            120 درهم للحصتين
          </h3>
          <p className="text-lg md:text-xl text-alice-blue/90 leading-relaxed max-w-4xl mx-auto px-4 fade-in fade-in-delay-3">
            حصتين لمدة ساعة وربع مع مدربة متخصصة - يمكن الإلغاء قبل 48 ساعة
          </p>
        </div>
        
        {/* Main Package Card */}
        <div className="mb-8 md:mb-16 flex justify-center fade-in fade-in-delay-4">
          <div className="relative bg-gray-800/40 backdrop-blur-sm rounded-2xl md:rounded-3xl border border-gray-600/30 p-6 md:p-12 w-full max-w-4xl transition-all duration-500 hover:bg-gray-800/50 hover:border-gray-500/40 group scale-hover">
            <div className="text-center">
              <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-10 group-hover:text-alice-blue transition-colors duration-300">حصة القيادة المرنة</h3>
              
              {/* Features List */}
              <div className="space-y-3 md:space-y-6 text-alice-blue/90 text-base md:text-xl max-w-3xl mx-auto">
                {[
                  'مدة الحصتين: ساعة وربع (75 دقيقة)',
                  'مواعيد مرنة 7 أيام في الأسبوع',
                  'أوقات متاحة: 4:00 صباحاً - 8:00 مساءاً',
                  'مدربة خاصة ومتخصصة',
                  'يمكن إلغاء الحصة قبل 48 ساعة مجاناً',
                  'دعم عبر الواتساب 24/7',
                  'تقرير مفصل بعد كل حصة'
                ].map((feature, index) => (
                  <p 
                    key={index}
                    className="text-center leading-relaxed transform transition-all duration-300 hover:text-white hover:scale-105"
                  >
                    {feature}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Cancellation Policy */}
        <div className="mb-12 md:mb-20 flex justify-center">
          <div className="relative bg-gray-800/40 backdrop-blur-sm rounded-2xl md:rounded-3xl border border-gray-600/30 p-6 md:p-12 w-full max-w-4xl transition-all duration-500 hover:bg-gray-800/50 group scale-hover fade-in fade-in-delay-4">
            <div className="text-center">
              <h4 className="text-xl md:text-3xl font-bold text-alice-blue mb-4 md:mb-8 group-hover:text-white transition-colors duration-300">سياسة الإلغاء</h4>
              <div className="max-w-3xl mx-auto">
                <p className="text-alice-blue/80 text-base md:text-xl leading-relaxed text-center group-hover:text-alice-blue transition-colors duration-300">
                  يمكن إلغاء الحصة مجاناً قبل 48 ساعة من موعدها المحدد. الإلغاء بعد هذا الوقت قد يتطلب دفع رسوم إضافية.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center fade-in fade-in-delay-4">
          <button 
            onClick={scrollToContact}
            className="bg-celestial-blue hover:bg-celestial-blue/90 text-white font-bold py-3 md:py-5 px-8 md:px-16 rounded-full text-lg md:text-2xl transition-all duration-300 scale-hover shadow-2xl hover:shadow-celestial-blue/30"
          >
            احجزي حصتك الآن
          </button>
        </div>
      </div>
    </section>
  );
};

export default Packages; 